import { lazy } from 'react'

// Engagement overview
export const EngagementOverviewPage = lazy(() =>
  import('@features/engagement/pages/EngagementOverviewTab').then((m) => ({
    default: m.EngagementOverviewTab,
  }))
)
export const EngagementAnalyticsPage = lazy(() =>
  import('@features/engagement/pages/AnalyticsTab').then((m) => ({
    default: m.AnalyticsTab,
  }))
)
export const EngagementCompetitivePage = lazy(() =>
  import('@features/engagement/pages/CompetitiveTab').then((m) => ({
    default: m.CompetitiveTab,
  }))
)
export const EngagementSettingsPage = lazy(() =>
  import('@features/engagement/pages/EngagementSettingsPage').then((m) => ({
    default: m.EngagementSettingsPage,
  }))
)

// Campaigns
export const CampaignsListPage = lazy(() =>
  import('@features/engagement/pages/CampaignsListPage')
)
export const CampaignDetailPage = lazy(() =>
  import('@features/engagement/pages/CampaignDetailPage')
)
export const CampaignCreatePage = lazy(() =>
  import('@features/engagement/pages/CampaignCreatePage').then((m) => ({
    default: m.CampaignCreatePage,
  }))
)

// Campaign detail tabs
export const CampaignOverviewTab = lazy(() =>
  import('@features/engagement/pages/campaign-tabs/CampaignOverviewTab').then((m) => ({
    default: m.CampaignOverviewTab,
  }))
)
export const CampaignPerformanceTab = lazy(() =>
  import('@features/engagement/pages/campaign-tabs/CampaignPerformanceTab').then((m) => ({
    default: m.CampaignPerformanceTab,
  }))
)
export const CampaignEnrollmentTab = lazy(() =>
  import('@features/engagement/pages/campaign-tabs/CampaignEnrollmentTab').then((m) => ({
    default: m.CampaignEnrollmentTab,
  }))
)
export const CampaignConfigurationTab = lazy(() =>
  import('@features/engagement/pages/campaign-tabs/CampaignConfigurationTab').then((m) => ({
    default: m.CampaignConfigurationTab,
  }))
)
export const CampaignActivityTab = lazy(() =>
  import('@features/engagement/pages/campaign-tabs/CampaignActivityTab').then((m) => ({
    default: m.CampaignActivityTab,
  }))
)

// Enrollments
export const EnrollmentListPage = lazy(() =>
  import('@features/engagement/pages/EnrollmentListPage')
)
export const EnrollmentDetailPage = lazy(() =>
  import('@features/engagement/pages/EnrollmentDetailPage')
)

// Rewards
export const RewardsCatalogListPage = lazy(() =>
  import('@features/engagement/pages/RewardsCatalogListPage').then((m) => ({
    default: m.RewardsCatalogListPage,
  }))
)
export const RewardDetailPage = lazy(() =>
  import('@features/engagement/pages/RewardDetailPage').then((m) => ({
    default: m.RewardDetailPage,
  }))
)
export const RewardOverviewTab = lazy(() =>
  import('@features/engagement/pages/reward-tabs/RewardOverviewTab').then((m) => ({
    default: m.RewardOverviewTab,
  }))
)
export const RewardUsageTab = lazy(() =>
  import('@features/engagement/pages/reward-tabs/RewardUsageTab').then((m) => ({
    default: m.RewardUsageTab,
  }))
)
export const RewardAnalyticsTab = lazy(() =>
  import('@features/engagement/pages/reward-tabs/RewardAnalyticsTab').then((m) => ({
    default: m.RewardAnalyticsTab,
  }))
)

// Points Ledger
export const PointsLedgerListPage = lazy(() =>
  import('@features/engagement/pages/PointsLedgerListPage').then((m) => ({
    default: m.PointsLedgerListPage,
  }))
)
export const CustomerPointsDetailPage = lazy(() =>
  import('@features/engagement/pages/CustomerPointsDetailPage').then((m) => ({
    default: m.CustomerPointsDetailPage,
  }))
)

// Tier Management
export const TierManagementPage = lazy(() =>
  import('@features/engagement/pages/TierManagementPage').then((m) => ({
    default: m.TierManagementPage,
  }))
)
export const TierDetailPage = lazy(() =>
  import('@features/engagement/pages/TierDetailPage').then((m) => ({
    default: m.TierDetailPage,
  }))
)
